import React, { useEffect, useState } from 'react'
import Modal from 'react-responsive-modal'
import { useDispatch, useSelector } from 'react-redux'
import styles from './styles.module.css'
import { useFormik } from 'formik'
import { Input } from '../../components/ModalInputs'
import * as Yup from 'yup'
import ModalFooter from '../../components/ModalFooter/ModalFooter'
import { getTvProgramType } from '../../actions/tvProgramType copy.js'
import { createTvProgramSchedule, updateTvProgramSchedule } from '../../actions/tvProgramSchedule.js'
import CustomSelect from '../../components/CustomSelect'
import { arrayForSelect } from '../../utils/arrayForSelect'
import Button from '../../components/Button'
import moment from 'moment'

const validationSchema = Yup.object({
  name: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'),

})

export default function ModalComponent({ data, closeModal, height, addMode, filters, newTime }) {

  const dispatch = useDispatch()

  const { list } = useSelector(state => state.tv_program_type)

  const [image, setImage] = useState(null); // ДЛЯ СНИМКА 
  const [subfolder, setSubfolder] = useState(null); // ДЛЯ СНИМКА 


  useEffect(() => {
    dispatch(getTvProgramType())
  }, [])

  useEffect(() => {
    setFieldValue('time_part', newTime)
  }, [newTime])

  const handleCreate = (values) => {
    dispatch(createTvProgramSchedule(values, filters, subfolder, image))
    closeModal()
  }

  const handleUpdate = ({ id, ...values }) => {
    dirty && dispatch(updateTvProgramSchedule(id, values, filters))
    closeModal()
  }

  const {
    values,
    errors,
    touched,
    dirty, // проверяет есть ли изменения
    submitCount,
    handleChange,
    handleSubmit,
    setFieldValue
  } = useFormik({
    initialValues: data,
    enableReinitialize: true,
    validateOnChange: true,
    validationSchema: validationSchema,
    onSubmit: addMode ? handleCreate : handleUpdate
  })

  const error = (fieldName) => (touched[fieldName] || submitCount) && errors[fieldName]

  const handlePick = (sub) => {
    setSubfolder(sub)
    document.getElementById('filePicker').click()
  }
  const handleChangeFile = (e) => {
    setImage(Object.values(e.target.files)[0])
  }

  const fetchPhoto = async (id) => {
    // const { data } = await api.get(`/cook_team/images/${id}`, { responseType: 'blob' })
    setImage(data)
  }

  useEffect(() => {
    if (data && !addMode) {
      fetchPhoto(values.id)
    }
  }, [data])

  return (
    <Modal
      open={!!data}
      onClose={() => false}
      showCloseIcon={false}
      height={height}
      classNames={{
        // overlay: styles.overlay,
        modal: styles.custom
      }}
    >
      <>
        <div className={styles.modalLocal} >
          <div className={styles.tabWrapper} >
            <div className={styles.inputsRow}>
              <Input
                type="date"
                label='День'
                // value={time}
                name='date_part'
                // onChange={handleChange}
                value={moment(values.date_part).format("YYYY-MM-DD")}
              // onChange={(e) => setFieldValue('date', (moment(e.target.value).format("YYYY-MM-DDTHH:mm")))}
              />
            </div>
            <br />

            <div className={styles.inputsRow}>
              <Input
                label='Название'
                name='name'
                value={values.name}
                error={error('name')}
                onChange={handleChange}
                style={{ width: '600px' }}
              />
            </div>
            <div className={styles.inputsRow}>
              <CustomSelect
                title='Тип программы'
                valuesName="type"
                value={values.type}
                options={list && arrayForSelect(list, 'name', 'id')}
                width={300}
                setFieldValue={setFieldValue}
              />
            </div>
            <br />

            <div className={styles.inputsRow}>
              <Input
                label='Анонс'
                name='name'
                onChange={handleChange}
                style={{ width: '600px' }}
                placeholder={values.announcement_file}
              />
              <div className={styles.buttons_wrap}>
                <div className={styles.buttons}>
                  <>
                    <Button onClick={() => handlePick('announce')} className={styles.buttonTv}>{'+'}</Button>
                    <input
                      className={styles.hidden}
                      type='file'
                      onChange={(e) => handleChangeFile(e)}
                      // accept="image/*"
                      id='filePicker'
                    />
                  </>

                </div>
              </div>
            </div>
            <div className={styles.inputsRow}>
              <Input
                label='Видео '
                name='name'
                onChange={handleChange}
                style={{ width: '600px' }}
              />
              <div className={styles.buttons_wrap}>
                <div className={styles.buttons}>
                  <>
                    <Button onClick={() => handlePick('video')} className={styles.buttonTv}>{'+'}</Button>
                    <input
                      className={styles.hidden}
                      type='file'
                      onChange={(e) => handleChangeFile(e)}
                      // accept="image/*"
                      id='filePicker'
                    />
                  </>

                </div>
              </div>
            </div>
            <div className={styles.inputsRow}>
              <textarea
                label='Видео '
                name='name'
                style={{ width: '500px', height: '300px' }}
              >
              </textarea>

              <div>
                <div className={styles.buttons_wrap}>
                  <div className={styles.buttons}>
                    <>
                      <Button onClick={() => handlePick('photo')} className={styles.buttonTv}>{'Создать из видео'}</Button>
                      <input
                        className={styles.hidden}
                        type='file'
                        onChange={(e) => handleChangeFile(e)}
                        // accept="image/*"
                        id='filePicker'
                      />
                    </>

                  </div>
                </div>
                <div className={styles.buttons_wrap}>
                  <div className={styles.buttons}>
                    <>
                      <Button onClick={handlePick} className={styles.buttonTv}>{'Выбрать'}</Button>
                      <input
                        className={styles.hidden}
                        type='file'
                        onChange={(e) => handleChangeFile(e)}
                        // accept="image/*"
                        id='filePicker'
                      />
                    </>

                  </div>
                </div>
                <div className={styles.buttons_wrap}>
                  <div className={styles.buttons}>
                    <>
                      <Button onClick={handlePick} className={styles.buttonTv}>{'Очистить'}</Button>
                      <input
                        className={styles.hidden}
                        type='file'
                        onChange={(e) => handleChangeFile(e)}
                        // accept="image/*"
                        id='filePicker'
                      />
                    </>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ModalFooter handleSubmit={handleSubmit} closeModal={closeModal} />
      </>
    </Modal>

  )
}
